var map = {
	"./aboutUs_coreAdvantage_founder.png": 7797,
	"./aboutUs_coreAdvantage_productCan.png": 6277,
	"./aboutUs_coreAdvantage_rdCapability.png": 537,
	"./aboutUs_coreAdvantage_stateBarriers.png": 5453,
	"./aboutUs_coreTeam_CEO.png": 7881,
	"./aboutUs_coreTeam_CPO.png": 9071,
	"./aboutUs_coreTeam_CTO.png": 5293,
	"./companyIntro_img.png": 6238,
	"./companyIntro_logos_img.png": 7416,
	"./coreAdvantages_img.png": 1550,
	"./coreTeam_img.png": 4599,
	"./joinUs_img.png": 3772,
	"./pc_header.png": 80,
	"./phone_header.png": 7069
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1338;